import { useContext } from 'react'

import assetInventoryContext from 'contexts/AssetInventoryContext'

const useAssetInventory = () => {
  const context = useContext(assetInventoryContext)

  if (context === undefined) {
    throw new Error(
      'useAssetInventory must be used within a assetInventoryContext.Provider',
    )
  }

  return {
    assetInventories: context.assetInventories,
    assetInventoryCategories: context.assetInventoryCategories,
    loadingInventories: context.loadingInventories,
    loadingCategories: context.loadingCategories,
    refreshInventories: context.refreshInventories,
    refreshCategories: context.refreshCategories,
    setAssetInventoryProps: context.setAssetInventoryProps,
    setAssetInventoryCategoryProps: context.setAssetInventoryCategoryProps,
    isLoading: context.isLoading,
    refresh: context.refresh,
    setLoading: context.setLoading,
  }
}

export default useAssetInventory
